export default {

  searchDocumentsTile: {
    title: 'Forms and guides',
    text: 'Find all the forms and guides related to your products.',
    search: 'Search',
  },
};
